<template>
<div class="FtabNavContainer">
  <el-tabs type="border-card" v-model="menuTabsValue" closable @tab-remove="removeTab" @tab-click="selectTab">
    <el-tab-pane :key="item.id" v-for="item in menuTabs" :label="item.name" :name="item.name" :path="item.componentUrl"></el-tab-pane>{{menuTabs}}
  </el-tabs>
  <div class="closeTabs" @click="closeOtherTabs">关闭其他</div>
</div>
</template>

<script>
export default {
  data() {
    return {
      menuTabsValue: "",
      tabsMenu: [
        // {
        //   name: '设备总览',
        //   url: '/equipmentM',
        //   componentName: 'equipmentM',
        //   imgPath: require("../../assets/img/leftEquipment.png")
        // }, {
        //   name: '故障历史',
        //   url: '/faulthistory',
        //   componentName: 'faulthistory',
        //   imgPath: require("../../assets/img/leftEquipment.png")
        // }, {
        //   name: '单位信息',
        //   url: '/unitInfo',
        //   componentName: 'unitInfo',
        //   imgPath: require("../../assets/img/leftUnit.png")
        // }, {
        //   name: '区域管理',
        //   url: '/regionalM',
        //   componentName: 'regionalM',
        //   imgPath: require("../../assets/img/leftRegional.png")
        // },
        // {
        //   name: '角色管理',
        //   url: '/rolesM',
        //   componentName: 'rolesM',
        //   imgPath: require("../../assets/img/leftRegional.png")
        // },{
        //   name: '子租户管理',
        //   url: '/childOrg',
        //   componentName: 'childOrg',
        //   imgPath: require("../../assets/img/leftRegional.png")
        // },
        // {
        //   name: '用户管理',
        //   url: '/personnelM',
        //   componentName: 'personnelM',
        //   imgPath: require("../../assets/img/leftPersonnel.png")
        // }, {
        //   name: '设备管理',
        //   url: '/deviceM',
        //   componentName: 'deviceM',
        //   imgPath: require("../../assets/img/leftDevice.png")
        // }, {
        //   name: '报警历史',
        //   url: '/alarmHistory',
        //   componentName: 'alarmHistory',
        //   imgPath: require("../../assets/img/leftAlarm.png")
        // }, 
        // // {
        // //   name: '自查记录',
        // //   url: '/selfR',
        // //   componentName: 'selfR',
        // //   imgPath: require("../../assets/img/leftAlarm.png")
        // // }
        // // , {
        // //   name: '巡检点管理',
        // //   url: '/patrolM',
        // //   componentName: 'patrolM',
        // //   imgPath: require("../../assets/img/leftAlarm.png")
        // // },
        //  {
        //   name: '巡检模板',
        //   url: '/patrolTemplate',
        //   componentName: 'patrolTemplate',
        //   imgPath: require("../../assets/img/leftAlarm.png")
        // }, {
        //   name: '巡检记录',
        //   url: '/inspectRecord',
        //   componentName: 'inspectRecord',
        //   imgPath: require("../../assets/img/leftAlarm.png")
        // }, {
        //   name: '系统设置',
        //   url: '/systemSet',
        //   componentName: 'systemSet',
        // }, {
        //   name: '组织管理',
        //   url: '/orgM',
        //   componentName: 'orgM',
        // }, 
        // // {
        // //   name: '隐患处理记录',
        // //   url: '/hiddenDanger',
        // //   componentName: 'hiddenDanger',
        // // }, 
        //  {
        //   name: '隐患管理',
        //   url: '/dangerM',
        //   componentName: 'dangerM',
        // },{
        //   name: '日志列表',
        //   url: '/logM',
        //   componentName: 'logM',
        // }, {
        //   name: '首页',
        //   url: '/homePage',
        //   componentName: 'homePage',
        // },
        // //  {
        // //   name: '设备类型',
        // //   url: '/deviceType',
        // //   componentName: 'deviceType',
        // // }, 
        // {
        //   name: '首页配置',
        //   url: '/homeConfig',
        //   componentName: 'homepageConfig',
        // }, {
        //   name: '巡检类型',
        //   url: "/patrolType",
        //   componentName: 'patrolType',
        // },
        // {
        //   name: "巡检项",
        //   url: "/patrolItem",
        //   componentName: 'patrolItem',
        // },
        // {
        //   name: "巡检计划",
        //   url: "/patrolPlan",
        //   componentName: 'patrolPlan',
        // },{
        //   name: "巡检统计",
        //   url: "/patrolSta",
        //   componentName: 'patrolSta',
        // },
        // {
        //   name: '巡检点',
        //   url: "/patrolPoint",
        //   componentName: 'patrolPoint',
        // },
      ],
      menuTabs: [],
      menuList:[]
    };
  },
  watch: {
    $route(nV, oV) {
      // console.log(nV);
      let tabsMenu = this.tabsMenu;
      let menuTabs = this.menuTabs;
      for (var i = 0; i < menuTabs.length; i++) {
        if (menuTabs[i].componentUrl == nV.path) {
          this.menuTabsValue = menuTabs[i].name;
          break;
        }
      }
      if (i != menuTabs.length) {
        return;
      }
      tabsMenu.forEach((tv, j) => {
        if (tv.componentUrl == nV.path) {
          menuTabs.push(tabsMenu[j]);
          this.menuTabsValue = tabsMenu[j].name;
        }
      });
      this.menuTabs = menuTabs;
    }
  },
  created() {
    this.getMenuData();
  },
  methods: {
    removeTab(targetName) {
      // console.log(targetName)
      let tabs = this.menuTabs;
      if (tabs.length > 1) {
        let activeName = this.menuTabsValue;
        // console.log(this.menuTabsValue)
        if (activeName === targetName) {
          tabs.forEach((tab, index) => {
            if (tab.name === targetName) {
              let nextTab = tabs[index + 1] || tabs[index - 1];
              // console.log(nextTab);
              if (nextTab) {
                activeName = nextTab.name;
                this.$router.push(nextTab.componentUrl);
              }
            }
          });
        }
        this.menuTabsValue = activeName;
        this.menuTabs = tabs.filter(tab => tab.name !== targetName);
      } else {
        this.$message({
          message: "最后一项不可关闭",
          type: "info",
          duration: 5000
        });
      }
    },
    selectTab(selected) {
      this.$router.push(selected.$attrs.path);
    },
    getMenuData() {
         // console.log(this.$route);
        this.request
          .get("/front/system/module/query/tree")
          .then((res) => {
            //左侧菜单
            // console.log(res);
            if (res.code == 200) {
              this.menuList=res.data           
              this.menuList.forEach((val) => {
                if(val.children!=null){
                  val.children.forEach(item=>{
                    this.tabsMenu.push(item)
                    if(item.children!=null) {
                      item.children.forEach(item2 => {
                        this.tabsMenu.push(item2)
                      })
                    }
                  })
                }else{
                  this.tabsMenu.push(val)
                }
              });
              // console.log(this.tabsMenu)
              // console.log(this.$route.name)
              this.tabsMenu.forEach((v, i) => {
                if (v.componentUrl == '/'+this.$route.name) {
                  this.menuTabs.push(this.tabsMenu[i]);
                  this.menuTabsValue = this.tabsMenu[i].name;
                }
              });
            } else if (res.code == 500) {
              this.msg.warn(res.msg)
            }
          })
          .catch((error) => {
            console.log(error);
          });
    },
    closeOtherTabs() {
      // console.log(this.menuTabs, this.menuTabsValue);
      let tabs = this.menuTabs;
      tabs = tabs.filter(tab => tab.name == this.menuTabsValue);
      this.menuTabs = tabs;
    }
  }
};
</script>

<style lang="scss">
.FtabNavContainer {
  padding-right: 50px;

  .el-tabs {
    border: none;
    box-shadow: 0 0 0 0;

    .el-tabs__header {
      background: #fff;
      border: none;
      height: 35px;

      .el-tabs__nav {
        background: #f0f2f5;
        height: 32px;
        padding: 2px;
        border-radius: 4px;
        box-sizing: content-box;

        .el-tabs__item {
          height: 32px;
          line-height: 32px;
          padding: 0 10px;
          font-size: 14px;
          color: #555;
          border: none;
          margin: 0 1px;
        }

        .is-active {
          background: rgba(255, 255, 255, 1);
          border-radius: 2px;
          color: #4291ff;
          font-family: PingFangBold;
        }
      }

      .el-tabs__nav-prev {
        height: 36px;
        line-height: 36px;
      }

      .el-tabs__nav-next {
        height: 36px;
        line-height: 36px;
      }
    }

    .el-tabs__content {
      display: none;
    }
  }

  .closeTabs {
    position: absolute;
    right: 8px;
    top: 4px;
    font-size: 12px;
    width: 30px;
    line-height: 14px;
    color: #999;
    cursor: pointer;

    &:hover {
      color: #4291ff;
    }
  }
}
</style>
